import { ApiHelper } from "./ApiHelper";

export class EnvironmentHelper {
  static Api = "";
  static ContentRoot = "";
  static PlayerRoot = "";
  static GoogleAnalyticsTag = "";
  static StripeKey = "";
  static AdminRoot = "https://admin.signpresenter.com"

  static init = () => {
    EnvironmentHelper.AdminRoot = window.location.protocol + "//" + window.location.host;
    switch (process.env.REACT_APP_STAGE) {
      case "staging": EnvironmentHelper.initStaging(); break;
      case "prod": EnvironmentHelper.initProd(); break;
      default: EnvironmentHelper.initDev(); break;
    }

    ApiHelper.apiConfigs = [
      { keyName: "Api", url: EnvironmentHelper.Api, jwt: "", permissions: [] },
    ];
  }

  static initDev = () => {
    EnvironmentHelper.Api = process.env.REACT_APP_API_URL || "";
    EnvironmentHelper.ContentRoot = process.env.REACT_APP_CONTENT_ROOT || "";
    EnvironmentHelper.PlayerRoot = process.env.REACT_APP_PLAYER_ROOT || "";
    EnvironmentHelper.GoogleAnalyticsTag = process.env.REACT_APP_GOOGLE_ANALYTICS || "";
    EnvironmentHelper.StripeKey = process.env.REACT_APP_STRIPE_KEY || "";
  }


  //NOTE: None of these values are secret.
  static initStaging = () => {
    // EnvironmentHelper.Api = "https://testapi.signpresenter.com";
    EnvironmentHelper.Api = process.env.REACT_APP_API_URL || "http://localhost:8900";

    EnvironmentHelper.ContentRoot = "https://testcontent.signpresenter.com";
    EnvironmentHelper.PlayerRoot = "https://play.signpresenter.com";
    EnvironmentHelper.GoogleAnalyticsTag = "";
    EnvironmentHelper.StripeKey = "pk_test_dbGZQcKoNMDcjZLmWdcTcxjM";
  }

  static initProd = () => {
    EnvironmentHelper.Api = "https://api.signpresenter.com";
    EnvironmentHelper.ContentRoot = "https://content.signpresenter.com";
    EnvironmentHelper.PlayerRoot = "https://play.signpresenter.com";
    EnvironmentHelper.GoogleAnalyticsTag = "";
    EnvironmentHelper.StripeKey = "pk_live_2mSGEZFC9idKPIp8LfN4ymgc";
  }

}
